import { Link } from "react-router-dom";
import logo from "@/assets/logo.png";

export default function PublicNav() {
  return (
    <header className="absolute top-0 inset-x-0 z-30" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="public-logo" className="flex items-center">
          <img src={logo} alt="Magical Villas Orlando — Luxury Homes" className="h-24 sm:h-32 w-auto drop-shadow-lg" />
        </Link>
        <nav className="flex items-center gap-7 text-sm font-medium text-white/90">
          <a href="#villas" className="hidden sm:inline hover:text-white transition-colors">Villas</a>
          <a href="#contact" className="hidden sm:inline hover:text-white transition-colors">Contact</a>
          <Link to="/login" data-testid="manager-login-link" className="bg-white/15 hover:bg-white/25 backdrop-blur-md border border-white/30 rounded-full px-5 py-2 transition-colors">
            Manager Login
          </Link>
        </nav>
      </div>
    </header>
  );
}
